import { RouterState } from 'react-router-redux';

export interface AppState{
  messageState: MessageState;
  routerState: RouterState;
  authState: AuthState;
  sessionState?: SessionState; 
}

export interface SessionState{
  sessionId: string;
}

export interface AuthState{
  isAuthenticated?: boolean;
  authToken?: string;
  expertId?: string;
  provider?: string;
  queues?: string[];
  technicianName?: string;
}

export interface MessageCategory {
  id?: number;
  messages: Messages;
  categoryName: string;
  displayOrder: number;
}

export interface MessageState {
  _messages: Messages;  
  messages: Messages;
  apiError?: AppError; 
  statusMessage?: StatusMessage;
  isSearchLoading?: boolean;
  hasSearchQuery: boolean;
  filteredMessages: Messages;
  isAppLoaded?: boolean;
  isAddMessagesInProgress?: boolean;
  isEditMessagesInProgress?: boolean;
  messageCategories: MessageCategory[];
  categoryAddInProgress?: boolean;
}


export const initialMessageState: MessageState = {
  messages: [],
  filteredMessages: [],
  _messages: [],
  hasSearchQuery: false,
  messageCategories: [],
};

export interface AppError {
  message: string;
}

export interface StatusMessage {
  status: Status;  
  header?: string;
  message?: string;
  icon?: any;
  color?: string;
  timeout?: number;
}

export interface Message {
  text: string;
  id: number;
  usageCount?: number;
  displayOrder?: number;
  categories:MessageCategoryAttributes[];

}

export interface MessageCategoryAttributes {
  id?: number;
  categoryName?: string;
  displayOrder: number;
}

export type Messages = Message[];

export type Status = 'error' | 'request' | 'success';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/index.ts